import { useState } from "react";
import { ZoomIn } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import * as VisuallyHidden from "@radix-ui/react-visually-hidden";

/**
 * Official product artwork display. Shows the image inline; tap/click opens a
 * large readable view. The artwork is never altered — this only zooms it.
 */
const ArtworkZoom = ({ src, alt, testId, className = "" }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid={testId}
        aria-label={`${alt} — tap to enlarge`}
        className={`relative block w-full cursor-zoom-in rounded-2xl overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.08)] focus:outline-none focus:ring-2 focus:ring-sage group ${className}`}
      >
        <img src={src} alt={alt} className="w-full h-auto" loading="lazy" />
        <span className="absolute bottom-3 right-3 inline-flex items-center gap-1.5 bg-white/90 text-ink text-sm font-medium rounded-full px-3 py-1.5 shadow group-hover:bg-white">
          <ZoomIn className="h-4 w-4" aria-hidden="true" /> Tap to enlarge
        </span>
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-4xl w-[95vw] max-h-[90vh] overflow-auto bg-cream p-3 sm:p-5" data-testid={`${testId}-zoom`}>
          <VisuallyHidden.Root>
            <DialogTitle>{alt}</DialogTitle>
          </VisuallyHidden.Root>
          <img src={src} alt={alt} className="w-full h-auto rounded-xl" />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ArtworkZoom;
